var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { ViewLayout } from '../../models/view-layout.enum';
import { ViewService } from '../../view.service';
import { LayoutService } from '../../layout.service';
import { Select } from '@ngxs/store';
import { ViewState } from '../../state/view.state';
import { Observable, Subject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { ViewLayoutStatus } from '../../models/view-layout-status.enum';
var ViewColumnToggleComponent = /** @class */ (function () {
    function ViewColumnToggleComponent(viewService, layoutService, changeDetectorRef) {
        this.viewService = viewService;
        this.layoutService = layoutService;
        this.changeDetectorRef = changeDetectorRef;
        this.ngUnsubscribe = new Subject();
        this.isIn = false;
    }
    ViewColumnToggleComponent.prototype.ngOnInit = function () {
        var _this = this;
        combineLatest(this.chapter$, this.layout$)
            .pipe(takeUntil(this.ngUnsubscribe)).subscribe(function (_a) {
            var _b = __read(_a, 2), chapter = _b[0], layout = _b[1];
            _this.isIn = layout.column.status === ViewLayoutStatus.Collapse;
            _this.changeDetectorRef.markForCheck();
        });
    };
    ViewColumnToggleComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    ViewColumnToggleComponent.prototype.isVisible = function () {
        return this.layoutService.isVisible(ViewLayout.ColumnToggle);
    };
    ViewColumnToggleComponent.prototype.handleToggleClick = function () {
        this.viewService.toggleColumn();
        this.changeDetectorRef.markForCheck();
    };
    __decorate([
        Select(ViewState.getLayout),
        __metadata("design:type", Observable)
    ], ViewColumnToggleComponent.prototype, "layout$", void 0);
    __decorate([
        Select(StoryChaptersState.getSelectedChapter),
        __metadata("design:type", Observable)
    ], ViewColumnToggleComponent.prototype, "chapter$", void 0);
    return ViewColumnToggleComponent;
}());
export { ViewColumnToggleComponent };
